module.exports = __webpack_public_path__ + "img/profile-female.fa539ac8.svg";